import { useEffect, useState, useRef } from 'react'

type Props = {
  in: boolean
  children: React.ReactNode
  className: string
  classNameOut: string
}

export const Animate = ({
  in: isVisible,
  children,
  className,
  classNameOut,
}: Props) => {
  const [shouldRender, setShouldRender] = useState(isVisible)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true)
    } else if (ref.current) {
      const handleTransitionEnd = () => setShouldRender(false)
      const node = ref.current
      node.addEventListener('transitionend', handleTransitionEnd)

      return () =>
        node.removeEventListener('transitionend', handleTransitionEnd)
    }
  }, [isVisible])

  if (!shouldRender) return null

  return (
    <div ref={ref} className={`${className} ${isVisible ? '' : classNameOut}`}>
      {children}
    </div>
  )
}
